export const usePermissionConfig = () => {
  return {
    /**
     * 新增协议
     */
    XZ: 'OPS-XTPZ-XYCMS-XZ',
    /**
     * 启用、禁用
     */
    QYJY: 'OPS-XTPZ-XYCMS-QYJY',
    /**
     *  编辑
     */
    BJ: 'OPS-XTPZ-XYCMS-BJ',
  } as const;
};
